import _ from "lodash";
import { format, utcToZonedTime } from "date-fns-tz";

import {
  getProfileScheduleByName,
  PAUSE_INTERNET,
  PAUSE_INTERNET_SUCCESS,
  RESUME_INTERNET,
  RESUME_INTERNET_SUCCESS,
} from "../../store/schedules";
import { getTimezone } from "../../store/account";
import { getProfile, getInternetPauseSchedule } from "../../store/profiles";
import { calculatePauseTimeEnd } from "./pauseInternet.helpers";
import { getSubscriberId } from "../../store/info";

const INTERNET_PAUSE_SCHEDULE_NAME = "internet-pause";
export const INTERNET_PAUSE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm";

export const pauseInternet =
  (profileId, pausePeriod) =>
  async (dispatch, getState, { api }) => {
    const subscriberId = getSubscriberId(getState());
    const profile = getProfile(getState(), profileId);
    const currentSchedule =
      getInternetPauseSchedule(getState(), profileId) || {};

    const timezone = getTimezone(getState());
    const now = utcToZonedTime(Date.now(), timezone);

    const schedule = _.assign(currentSchedule, {
      name: INTERNET_PAUSE_SCHEDULE_NAME,
      type: INTERNET_PAUSE_SCHEDULE_NAME,
      timeZone: timezone,
      day: [],
      categories: [],
      enabled: true,
      timeStart: format(now, INTERNET_PAUSE_TIME_FORMAT),
      timeEnd: format(
        calculatePauseTimeEnd(now, pausePeriod),
        INTERNET_PAUSE_TIME_FORMAT,
      ),
      // We have to add 1 min for handling difference if timeStart is between 11:00:01 and 11:00:58
      // because we can't save seconds (or timestamp) to the backend
    });

    dispatch({ type: PAUSE_INTERNET });
    const { success } = await api.schedules.create(
      subscriberId,
      profile.name,
      schedule,
    );

    if (success) {
      dispatch(addPauseInternetSuccess({ profileId, schedule }));
    }
  };

export const unpauseInternet =
  (profileId) =>
  async (dispatch, getState, { api }) => {
    const subscriberId = getSubscriberId(getState());
    const profile = getProfile(getState(), profileId);
    const schedule = getProfileScheduleByName(
      getState(),
      profileId,
      INTERNET_PAUSE_SCHEDULE_NAME,
    );

    dispatch({ type: RESUME_INTERNET });
    const { success } = await api.schedules.delete(
      subscriberId,
      profile.name,
      INTERNET_PAUSE_SCHEDULE_NAME,
    );

    if (success) {
      dispatch(resumePausedInternetSuccess({ scheduleId: schedule.id }));
    }
  };

const addPauseInternetSuccess = (payload) => ({
  type: PAUSE_INTERNET_SUCCESS,
  payload,
});

const resumePausedInternetSuccess = (payload) => ({
  type: RESUME_INTERNET_SUCCESS,
  payload,
});
